import { Loader2 } from 'lucide-react';
import React from 'react'

const Button = ({
    children,
    type = 'button',
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    disabled = false,
    onClick,
    className = '',
    loading = false,
    ...props
}) => {
    const baseStyles = 'relative font-medium rounded-lg transition-all duration-300 flex items-center justify-center';

    const variants = {
        primary: 'bg-primary text-white hover:bg-primary-700 active:bg-primary-800',
        secondary: 'bg-secondary text-white hover:bg-secondary-700 active:bg-secondary-800',
        outline: 'bg-transparent border border-primary text-primary hover:bg-primary-50 active:bg-primary-100',
        text: 'bg-transparent text-primary hover:text-primary-700 active:text-primary-800 hover:bg-primary-50',
    };

    const sizes = {
        sm: 'text-sm py-2 px-3',
        md: 'text-base py-3 px-5',
        lg: 'text-lg py-4 px-6',
    };

    const widthClass = fullWidth ? 'w-full' : '';
    const disabledClass = disabled ? 'opacity-50 cursor-not-allowed' : 'transform hover:-translate-y-0.5 active:translate-y-0';

    return (
        <button
            type={type}
            className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${disabledClass} ${className}`}
            disabled={disabled}
            onClick={onClick}
            {...props}
        >
            {loading ? <Loader2 className="animate-spin" /> : <span className="relative z-10">{children}</span>}
            {variant === 'primary' && (
                <div className="absolute inset-0 overflow-hidden transition-opacity duration-300 rounded-lg opacity-0 hover:opacity-20">
                    <div className="absolute inset-0 bg-white mix-blend-overlay" />
                </div>
            )}
        </button>
    );
}

export default Button